import React, { useState } from 'react';
import Weight from '../ui/Weight.js';

export default (props) => {
	return <div className="harvest-record-summary-data">
		<h4><span className="date">{props.Date}</span><span className="invoice"># {props.InvoiceNumber}</span></h4>
		<div className="inline-weight"><Weight value={props.harvested} precision="0" /> ({props.GradeName}) <small>{ props.QuotedPrice && 'Quoted at $' + parseFloat(props.QuotedPrice).moneyFormat() }</small></div>
	</div>

}